import { Ref, forwardRef } from "react"
import * as yup from "yup"
import { Form, FormikProps } from "formik"
import { Formik } from "../../../../../shared/components/forms/SchemaFormik"
import { CreateOrEditDeliveryLocationFormValues, DeliveryLocationDetails } from "../deliveryLocationsTypes"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"
import { FormDeliveryLocationContent } from "./FormDeliveryLocationContent"
import { useDateTime } from "../../../../localization/useDateTime"

type CreateUpdateDeliveryLocationFormProps = Readonly<{
    initialValues: CreateOrEditDeliveryLocationFormValues
    onSubmit: (formData: DeliveryLocationDetails) => void
}>

type FormikRef = Ref<FormikProps<CreateOrEditDeliveryLocationFormValues>>

export const CreateUpdateDeliveryLocationForm = forwardRef(
    ({ initialValues, onSubmit }: CreateUpdateDeliveryLocationFormProps, ref: FormikRef) => {
        const { l10n } = useAppLocalization()
        const dateTimeFactory = useDateTime()

        const validationSchema = yup.object({
            name: yup.string().required(l10n.getString("required-field")),
            webshopId: yup.string().required(l10n.getString("required-field")),
            timeIntervalStart: yup.date(),
            timeIntervalEnd: yup
                .date()
                .min(
                    yup.ref("timeIntervalStart"),
                    l10n.getString("merchant-delivery-location-form-end-time-picker-min-error-label"),
                ),
        })

        function handleSubmit({
            timeIntervalStart,
            timeIntervalEnd,
            webshopId,
            ...rest
        }: CreateOrEditDeliveryLocationFormValues) {
            const modifyData = {
                ...rest,
                timeInterval: {
                    start: dateTimeFactory.formatTime(timeIntervalStart),
                    end: dateTimeFactory.formatTime(timeIntervalEnd),
                },
                webshop: webshopId ? { id: webshopId } : null,
            }
            onSubmit(modifyData)
        }

        return (
            <Formik<CreateOrEditDeliveryLocationFormValues>
                enableReinitialize
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={ref}
            >
                <Form>
                    <FormDeliveryLocationContent />
                </Form>
            </Formik>
        )
    },
)
